/* global angular */

export default function() {
  return function(obj) {
    var result = [];
    angular.forEach(obj, function(val) {
      result.push(val);
    });
    return result;
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/ToArray.js